var _a;
import { createSlice } from "@reduxjs/toolkit";
export var uiSliceInitialState = {
    isLoading: false,
    snackbar: null,
    error: null,
    success: null,
    modal: null,
};
var uiSlice = createSlice({
    name: "ui",
    initialState: uiSliceInitialState,
    reducers: {
        setLoading: function (state, _a) {
            var payload = _a.payload;
            state.isLoading = payload;
        },
        setSnackbar: function (state, _a) {
            var payload = _a.payload;
            console.log("Setting snackbar", payload);
            state.snackbar = payload;
        },
        setError: function (state, action) {
            state.error = action.payload;
        },
        setSuccess: function (state, action) {
            state.success = action.payload;
        },
        setModal: function (state, action) {
            console.log("Setting modal", action.payload);
            state.modal = action.payload;
        },
        clearState: function (state) {
            state.isLoading = false;
            state.error = null;
            state.success = null;
            state.modal = null;
        },
    },
});
export var selectUi = {
    isLoading: function (state) { return state.ui.isLoading; },
    snackbar: function (state) { return state.ui.snackbar; },
    error: function (state) { return state.ui.error; },
    success: function (state) { return state.ui.success; },
    modal: function (state) { return state.ui.modal; },
};
export var setLoading = (_a = uiSlice.actions, _a.setLoading), setSnackbar = _a.setSnackbar, setError = _a.setError, setSuccess = _a.setSuccess, setModal = _a.setModal, clearState = _a.clearState;
export var uiReducer = uiSlice.reducer;
